import styled from 'styled-components'

import { ISizedBox } from './SizedBoxComponent.types'

export const Container = styled.div<ISizedBox>`
  margin-top: ${({ size }) => size ?? 10}px;
`
